/**
 * @generated SignedSource<<253842bd2b449111a70633190eefd37c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueViewEntitlementField_servicedeskCustomerServiceEntitlementsField_EntitlementsField" | "ui_businessGoalsIssueViewField_GoalsInlineEditViewField" | "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField" | "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField" | "ui_issueViewLayoutPriorityField_IssueViewPriorityField" | "ui_issueViewLayoutSentimentField_IssueViewSentimentField" | "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField">;
  readonly " $fragmentType": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer";
};
export type relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$key = {
  readonly " $data"?: relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayCascadingSelectFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayGoalsFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayPriorityFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jsmSentimentCustomFieldFlag"
    }
  ],
  "kind": "Fragment",
  "name": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField"
    },
    {
      "condition": "jsmSentimentCustomFieldFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutSentimentField_IssueViewSentimentField"
        }
      ]
    },
    {
      "condition": "issueViewRelayCascadingSelectFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "issueViewEntitlementField_servicedeskCustomerServiceEntitlementsField_EntitlementsField"
    },
    {
      "condition": "issueViewRelayGoalsFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_businessGoalsIssueViewField_GoalsInlineEditViewField"
        }
      ]
    },
    {
      "condition": "issueViewRelayPriorityFieldFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutPriorityField_IssueViewPriorityField"
        }
      ]
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "0a7233464952bd75839d31fc50ff8223";

export default node;
